"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
/*
 * code modified from https://github.com/lyft/coloralgorithm/blob/1cef3987fdea2af8cfcc9b4bfd132ccf5684a030/src/curves.js
 */
const bezier_easing_1 = tslib_1.__importDefault(require("bezier-easing"));
exports.linear = bezier_easing_1.default(0.5, 0.5, 0.5, 0.5);
exports.easeInCubic = bezier_easing_1.default(0.55, 0.055, 0.675, 0.19);
exports.easeOutCubic = bezier_easing_1.default(0.215, 0.61, 0.355, 1);
exports.easeInOutCubic = bezier_easing_1.default(0.645, 0.045, 0.355, 1);
exports.easeInSine = bezier_easing_1.default(0.47, 0, 0.745, 0.715);
exports.easeOutSine = bezier_easing_1.default(0.39, 0.575, 0.565, 1);
exports.easeInOutSine = bezier_easing_1.default(0.445, 0.05, 0.55, 0.95);
exports.easeInQuad = bezier_easing_1.default(0.55, 0.085, 0.68, 0.53);
exports.easeOutQuad = bezier_easing_1.default(0.25, 0.46, 0.45, 0.94);
exports.easeInOutQuad = bezier_easing_1.default(0.455, 0.03, 0.515, 0.955);
exports.easeInQuart = bezier_easing_1.default(0.895, 0.03, 0.685, 0.22);
exports.easeOutQuart = bezier_easing_1.default(0.165, 0.84, 0.44, 1);
exports.easeInOutQuart = bezier_easing_1.default(0.77, 0, 0.175, 1);
exports.easeInCirc = bezier_easing_1.default(0.6, 0.04, 0.98, 0.335);
exports.easeOutCirc = bezier_easing_1.default(0.075, 0.82, 0.165, 1);
exports.easeInOutCirc = bezier_easing_1.default(0.785, 0.135, 0.15, 0.86);
exports.easeInQuint = bezier_easing_1.default(0.755, 0.05, 0.855, 0.06);
exports.easeOutQuint = bezier_easing_1.default(0.23, 1, 0.32, 1);
exports.easeInOutQuint = bezier_easing_1.default(0.86, 0, 0.07, 1);
exports.easeInExpo = bezier_easing_1.default(0.95, 0.05, 0.795, 0.035);
exports.easeOutExpo = bezier_easing_1.default(0.19, 1, 0.22, 1);
exports.easeInOutExpo = bezier_easing_1.default(1, 0, 0, 1);
exports.easeInBack = bezier_easing_1.default(0.6, -0.28, 0.735, 0.045);
exports.easeOutBack = bezier_easing_1.default(0.175, 0.885, 0.32, 1.275);
exports.easeInOutBack = bezier_easing_1.default(0.68, -0.55, 0.265, 1.55);
exports.muiHueCurve = bezier_easing_1.default(0.34, 0.1, 0.68, 1);
exports.muiSatCurve = bezier_easing_1.default(0.48, 0.78, 0.31, 0.99);
exports.muiValCurve = bezier_easing_1.default(0.4, 0.55, 0.66, 1);
